module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"discussion":"Discussion","returnToList":"Return to list"},"fr":{"discussion":"Discussion","returnToList":"Retour à la liste"}}')
  delete Component.options._Ctor
}
